<template>
  <component
    :is="divOrLink"
    :href="href"
    class="ml-2.5 relative tracking-slight rounded-l-full pr-3.5 py-2.5 border border-r-0 transition underline underline-offset-2 decoration-transparent"
    :class="{
      'font-medium text-white decoration-blue-600 border-blue-700 bg-gradient-to-r from-blue-900/80 via-blue-900 to-blue-800/80':
        activeRoute && divOrLink !== 'div',
      'border-transparent': !activeRoute || divOrLink === 'div',
      'font-normal text-white/80 hover:text-white hover:bg-blue-900/70':
        !activeRoute && divOrLink !== 'div',
      'pl-3.5': !!icon,
      'pl-4': !icon,
    }"
    :aria-current="activeRoute ? 'page' : undefined"
  >
    <span class="stack horizontal valign-center gap-3 w-full drop-shadow">
      <s-icon
        v-if="!!icon"
        :name="icon"
        :class="activeRoute ? 'text-s-red-200' : 'text-blue-200'"
      />
      <slot />
    </span>
  </component>
</template>
<script lang="ts" setup>
import {computed} from 'vue';
import SLink from '../../components/SLink.vue';
import {usePage} from '@inertiajs/vue3';
import SIcon from '../../design-system/SIcon.vue';

const {href, icon, activePattern, activeParams, activePrefix} = defineProps<{
  href?: string;
  icon?: string;
  activePattern?: string;
  activeParams?: Record<string, string>;
  activePrefix?: string | null;
}>();

const page = usePage();

const activeRoute = computed(() => {
  const path = page.url.split('?')[0];

  if (activePattern) {
    return route().current(activePattern, activeParams);
  }

  if (activePrefix) {
    return path === activePrefix || path.startsWith(`${activePrefix}/`);
  }

  return path === href;
});

const divOrLink = computed(() => {
  if (href) {
    return SLink;
  }

  return 'div';
});
</script>
